import React from "react";

// import "../tagger.styles.scss";
import CloseOutlined from "@mui/icons-material/CloseOutlined";
import { Popover, PopoverProps, Stack, Typography } from "@mui/material";

export const HintPopover: React.FC<PopoverProps> = (props) => {
  return (
    <Popover
      {...props}
      // classes={{ paper: "tagger-hint-popover" }}
      anchorOrigin={{
        vertical: "bottom",
        horizontal: "left"
      }}
    >
      <Stack sx={{ padding: "15px", lineHeight: "24p", fontWeight: "300" }}>
        <Stack
          direction="row"
          justifyContent="space-between"
          alignItems="center"
          sx={{
            marginBottom: "10px",
            fontWeight: "400"
          }}
        >
          <Typography variant="body1">How to upload and tag your PDF</Typography>
          <CloseOutlined onClick={(e) => props.onClose?.(e, "backdropClick")} />
        </Stack>
        <p>
          1. Click “Upload PDF”
          <br />
          2. Select a folder.
          <br />
          3. Select the investor, round and date of the file.
          <br />
          4. Once parsed, you can right click a value to select the measure.
          <br />
          5. Values also reflect in the table below. Add more manually or click to edit.
        </p>
      </Stack>
    </Popover>
  );
};
